import { render, staticRenderFns } from "./ReviewList.vue?vue&type=template&id=950c9720&scoped=true"
import script from "./ReviewList.vue?vue&type=script&lang=js"
export * from "./ReviewList.vue?vue&type=script&lang=js"
import style0 from "./ReviewList.vue?vue&type=style&index=0&id=950c9720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950c9720",
  null
  
)

export default component.exports